import styled from 'styled-components';
import { } from 'antd';

export const StyledSubForm = styled.div`
  background: ${(props) => props.theme.form.subSectionBackgroundColor};
  padding: 20px;
  min-height: 300px;
`;
export const StyledBox = styled.div`
  margin-top: 15px;
  height: 100%;
  width: 100%;
  border: 2px solid grey;,
  margin-left:15px;
`;
export const StyledBoxLabel = styled.div`
  color: #1a1919
  margin-top: -14px;
  position: absolute;
  left: 60px;
  width: 180px;
  text-align: center;
  background-color: #e5eaf0;
  
  font-weight: bold;
`;
